






























































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Element, ElementPostCopy, ElementPostMove, ElementType, Product, FileExport, ElementStatus, RegenerateWebpackResponse, CopyProcessedRelatedPartsResult, CopyProcessedRelatedPartsResponse, StructureError } from '@/models'
import { Utils } from '@/utils'
import { CvValueUtils } from '@/utils/cv-value-utils'
import { MutationTypes } from '@/store/mutation-types'
import { ActionTypes } from '@/store/action-types'
import {
  MODAL_DELETE_ID,
  TYPR_BOOK,
  TYPR_DIGITAL_COURSE,
  CV_VALUE_ELEMENT_RELATION_TYPE,
  CV_VALUE_SMA_TYPE_N3,
  CV_VALUE_SMA_TYPE_N4,
  PRODUCT_ELEMENTS_EXCEL_EXPORT_COMPLETE,
  PRODUCT_ELEMENTS_EXCEL_EXPORT_FOR_UPDATE,
  TYPR_WEBPACK_COURSE,
  CV_VALUE_CATEGORY_BLOCK,
  CV_VALUE_CATEGORY_ANEXO,
  CV_VALUE_CATEGORY_SECUENCIA_DIGITAL,
  CV_VALUE_CATEGORY_NIVELADOR,
  CV_VALUE_CATEGORY_UNIDAD,
  CV_VALUE_CATEGORY_RECURSOS_UNIDAD,
  ROLE_ADMIN, ROLE_SPECIAL, ROLE_EDITOR, ROLE_READ,
  ACCOUNT_ACTIONS_BUTTON_COPY_PROCESSED_RELATED_PARTS,
  STRUCTURE_ERROR_TYPE_DUPLICATED_CODE
} from '@/utils/constants'
import ApiClient from '@/services/api-client'
import { BaseTree } from '@he-tree/vue/vue2'
import { Stat } from '@he-tree/tree-utils'

@Component({
  components: {
    blockProductModal: () => import('@/components/modals/blockProductModal.vue'),
    importElementsProductModal: () => import('@/components/modals/importElementsProductModal.vue'),
    ProductMetadata: () => import('@/components/ProductMetadata.vue'),
    StructureNameField: () => import('@/components/productDetail/StructureNameField.vue'),
    StructureWebpackFields: () => import('@/components/productDetail/StructureWebpackFields.vue'),
    upsertElementModal: () => import('@/components/modals/upsertElementModal.vue'),
    UpsertTracingProductModal: () => import('@/components/modals/UpsertTracingProductModal.vue'),
    deleteModal: () => import('@/components/modals/deleteModal.vue'),
    CopyElementModal: () => import('@/components/modals/CopyElementModal.vue'),
    DuplicateElementModal: () => import('@/components/modals/DuplicateElementModal.vue'),
    StructureInfoElementModal: () => import('@/components/modals/StructureInfoElementModal.vue'),
    ElementHistoricalModal: () => import('@/components/modals/ElementHistoricalModal.vue'),
    CopyProcessedRelatedPartsResultModal: () => import('@/components/modals/CopyProcessedRelatedPartsResultModal.vue'),
    StructureErrorsModal: () => import('@/components/modals/StructureErrorsModal.vue'),
    ElementStatusFiles: () => import('@/components/productDetail/ElementStatusFiles.vue'),
    RelationToInfo: () => import('@/components/productDetail/RelationToInfo.vue'),
    RelationToListInfo: () => import('@/components/productDetail/RelationToListInfo.vue'),
    BaseTree
  }
})
export default class StructureTab extends Vue {
  @Prop({ required: true, type: Object }) product: Product
  @Prop({ required: true, type: Array }) elementStatusFiles: ElementStatus[]

  private Utils = Utils
  public PRODUCT_ELEMENTS_EXCEL_EXPORT_COMPLETE = PRODUCT_ELEMENTS_EXCEL_EXPORT_COMPLETE
  public PRODUCT_ELEMENTS_EXCEL_EXPORT_FOR_UPDATE = PRODUCT_ELEMENTS_EXCEL_EXPORT_FOR_UPDATE
  public ROLE_ADMIN = ROLE_ADMIN
  public ROLE_SPECIAL = ROLE_SPECIAL
  public ROLE_EDITOR = ROLE_EDITOR
  public ROLE_READ = ROLE_READ
  public ACCOUNT_ACTIONS_BUTTON_COPY_PROCESSED_RELATED_PARTS = ACCOUNT_ACTIONS_BUTTON_COPY_PROCESSED_RELATED_PARTS

  private copyTree = []

  @Watch('product', { deep: true })
  onProductChanged() {
    // @ts-ignore
    this.copyTree = this.$refs.tree.statsFlat
  }

  private disableSyncButton = false
  private categoriesToExpandCollapse = [CV_VALUE_CATEGORY_BLOCK, CV_VALUE_CATEGORY_ANEXO, CV_VALUE_CATEGORY_SECUENCIA_DIGITAL, CV_VALUE_CATEGORY_NIVELADOR, CV_VALUE_CATEGORY_UNIDAD, CV_VALUE_CATEGORY_RECURSOS_UNIDAD]

  // Modals params
  private modalDeleteId = MODAL_DELETE_ID
  private targetItemDelete: Element | null = null
  private selectedParent: Product | Element | null = null
  private elementUpdate: Element | null = null
  private elementParentTarget: Element | null = null
  private elementSelected: Element | null = null
  private elementHistoricalSelected: Element | null = null
  private itemSelected: Stat<Element> | null = null
  private copyProcessedResult: CopyProcessedRelatedPartsResult | null = null
  private copyProcessedMessage = ''
  private copyProcessedSuccess = true

  get isBook() {
    return this.product.type === TYPR_BOOK
  }

  get isDigitalCourse() {
    return this.product.type === TYPR_DIGITAL_COURSE
  }

  get isWebpack() {
    return this.product.type === TYPR_WEBPACK_COURSE
  }

  get isAutoGenerate() {
    return this.product.autoGenerate
  }

  get isEditable() {
    if (this.product.autoGenerate) {
      return false
    }
    if (this.product.synchronizeEc === false) {
      return false
    }
    return true
  }

  get showElementFileStatus() {
    return this.elementStatusFiles.length > 0
  }

  get productFiltered() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this
    const productCopy = vm.product
    productCopy.elements.forEach(function(element: Element) {
      const elementType = vm.getElementType(element.type)
      if (elementType?.childrenElementTypeAllowed) {
        element.childrens = element.elements
      }
      vm.filterElement(element)
    })
    return productCopy
  }

  private filterElement(element: Element) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this
    element.elements.forEach(function(element: Element) {
      const elementType = vm.getElementType(element.type)
      if (elementType?.childrenElementTypeAllowed) {
        element.childrens = element.elements
      }
      vm.filterElement(element)
    })
  }

  created() {
    this.selectedParent = this.product
    this.loadElementRelationType()
  }

  mounted() {
    this.closeDefaultNodes()
  }

  setTargetItemDelete(element: Element) {
    this.targetItemDelete = element
    this.$bvModal.show(this.modalDeleteId)
  }

  setModalAddElementTree(node: Element) {
    node.product = this.product // Set product (Needed in add element dialog)
    this.selectedParent = Object.assign({}, node)
    this.elementUpdate = Object.assign({}, null)
    this.$bvModal.show('upsertElementModal')
  }

  setModalAddElement() {
    this.selectedParent = Object.assign({}, this.product)
    this.elementUpdate = Object.assign({}, null)
    this.$bvModal.show('upsertElementModal')
  }

  setModalUpdateElement(element: Element, stat: Stat<Element>) {
    if (stat.parent && stat.parent !== undefined) {
      this.selectedParent = Object.assign({}, stat.parent.data as Element)
    } else {
      this.selectedParent = Object.assign({}, this.product)
    }
    this.elementUpdate = Object.assign({}, element)

    this.$bvModal.show('upsertElementModal')
  }

  closeDefaultNodes() {
    // @ts-ignore
    if (!this.$refs.tree.statsFlat) {
      return
    }
    // @ts-ignore
    for (const stat of this.$refs.tree.statsFlat) {
      const elementType = this.$store.getters.elementTypes.find((item: ElementType) => item.codeId === stat.data.type)
      if (!elementType || elementType === undefined) {
        continue
      }
      if (this.categoriesToExpandCollapse.indexOf(elementType.category) > -1) {
        stat.open = false
      }
    }
  }

  setCopyElement(elementParentTarget: Element) {
    this.elementParentTarget = Object.assign({}, elementParentTarget)
    this.$bvModal.show('copyElementModal')
  }

  setCopyMainElement() {
    this.elementParentTarget = null
    this.$bvModal.show('copyElementModal')
  }

  setElementInfoStructure(element: Element) {
    this.elementSelected = Object.assign({}, element)
    this.$bvModal.show('structureInfoElementModal')
  }

  setElementHistorical(element: Element) {
    this.elementHistoricalSelected = Object.assign({}, element)
    this.$bvModal.show('elementHistoricalModal')
  }

  exportStructure(element: Element, typeExcel: string) {
    this.$store.commit(MutationTypes.SET_LOADING, true)
    ApiClient.exportStructureElement(element.id, typeExcel)
      .then((file: FileExport) => {
        Utils.exportFile(file.file, file.fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
        this.$store.dispatch(ActionTypes.SHOW_TOAST, {
          title: this.$t('product_detail.structure.feedback.success_title_export_structure'),
          variant: 'success',
          message: this.$t('product_detail.structure.feedback.success_message_export_structure')
        })
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
      .catch(() => {
        this.$store.dispatch(ActionTypes.SHOW_TOAST, {
          title: this.$t('feedback.error_title_generic'),
          variant: 'danger',
          message: this.$t('feedback.error_message_generic')
        })
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
  }

  openAll() {
    // @ts-ignore
    this.$refs.tree.openAll()
  }

  closeAll() {
    // @ts-ignore
    this.$refs.tree.closeAll()
  }

  toggleExpand(stat: Stat<Element>) {
    stat.open = !stat.open
  }

  statHandler(stat: Stat<Element>) {
    const statFind = this.copyTree.find((item: Stat<Element>) => item.data.id === stat.data.id)
    if (statFind && (statFind as Stat<Element>).open === false) {
      stat.open = (statFind as Stat<Element>).open
    }

    return stat
  }

  openDuplicateElement(stat: Stat<Element>) {
    this.itemSelected = stat
    this.$bvModal.show('duplicateElementModal')
  }

  async duplicateElement(stat: Stat<Element>, numDuplications = 1) {
    if (!stat.parent) {
      return
    }

    const payload: ElementPostCopy = {
      elementIdToCopy: stat.data.id,
      parentElementIdTarget: stat.parent.data.id,
      productIdTarget: this.product.id,
      copyOnlyStructure: false
    }
    this.$store.commit(MutationTypes.SET_LOADING, true)
    let error = false
    for (let i = 0; i < numDuplications; i++) {
      try {
        await ApiClient.copyElement(payload, stat.data.id)
      } catch (ex: any) {
        error = true
      }
    }

    if (error) {
      this.$store.dispatch(ActionTypes.SHOW_TOAST, {
        title: this.$t('duplicate_element_modal_component.title'),
        variant: 'danger',
        message: this.$t('feedback.error_message_generic')
      })
    } else {
      this.$emit('elementUpdated')
      this.$store.dispatch(ActionTypes.SHOW_TOAST, {
        title: this.$t('duplicate_element_modal_component.title'),
        variant: 'success',
        message: this.$t('duplicate_element_modal_component.feedback.success')
      })
    }
    this.$store.commit(MutationTypes.SET_LOADING, false)
  }

  generateDigital(stat: Stat<Element>) {
    this.$store.commit(MutationTypes.SET_LOADING, true)
    ApiClient.generateDigital(stat.data.id)
      .then((element: Element) => {
        this.$emit('elementUpdated', element)
        this.$store.dispatch(ActionTypes.SHOW_TOAST, {
          title: this.$t('product_detail.structure.feedback.success_title_generate_digital'),
          variant: 'success',
          message: this.$t('product_detail.structure.feedback.success_message_generate_digital')
        })
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
      .catch((ex: any) => {
        this.$store.dispatch(ActionTypes.SHOW_TOAST, {
          title: this.$t('product_detail.structure.feedback.success_title_generate_digital'),
          variant: 'danger',
          message: `${ex.response.data.message}`
        })
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
  }

  private showGenerateDigital(stat: Stat<Element>) {
    if (stat == null || stat.data == null || stat.data.type === '') {
      return null
    }
    const elementType = this.$store.getters.elementTypes.find((item: ElementType) => item.codeId === stat.data.type)
    if (!elementType || elementType === undefined || !elementType.metadataAllowed) {
      return null
    }
    return elementType.metadataAllowed.split(',').includes('isDigitalN2')
  }

  private getElementType(codeId: string) {
    return Utils.findElementType(codeId, this.$store.getters.elementTypes)
  }

  private getElementTypeName(codeId: string) {
    return Utils.findElementTypeName(codeId, this.$store.getters.elementTypes)
  }

  private showTypeNodeEc(codeId: string): boolean {
    const type = Utils.findElementType(codeId, this.$store.getters.elementTypes)
    if (!type) {
      return false
    }
    return type.smaType === CV_VALUE_SMA_TYPE_N3 || type.smaType === CV_VALUE_SMA_TYPE_N4
  }

  private getCvValueName(codeId: string, type: string = CV_VALUE_ELEMENT_RELATION_TYPE) {
    const typeName = CvValueUtils.getCvValueName(codeId, type)
    if (typeName === codeId) {
      return ''
    }
    return typeName
  }

  private loadElementRelationType() {
    return CvValueUtils.getCvValuesByType(CV_VALUE_ELEMENT_RELATION_TYPE)
  }

  private async importProductStructure() {
    // Disable block button 15 seconds for avoid multiple click
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this
    this.disableSyncButton = true
    setTimeout(function() { vm.disableSyncButton = false }, 15000)

    ApiClient.importECFromSharepoint(this.product.code).then(function() {
      vm.$store.dispatch(ActionTypes.SHOW_TOAST, {
        title: vm.$t('product_detail.structure.button_synchronize'),
        variant: 'success',
        message: `${vm.$t('product_detail.structure.synchronize_product')} ${vm.product.code}. ${vm.$t('product_detail.structure.synchronize_feedback_success')}`
      })
    }, function() {
      vm.$store.dispatch(ActionTypes.SHOW_TOAST, {
        title: vm.$t('product_detail.structure.button_synchronize'),
        variant: 'danger',
        message: `${vm.$t('product_detail.structure.synchronize_product')} ${vm.product.code}. ${vm.$t('product_detail.structure.synchronize_feedback_error')}`
      })
    })
  }

  private unBlockSynchronizeEc() {
    const payload = { synchronizeEc: true }
    this.$store.commit(MutationTypes.SET_LOADING, true)
    ApiClient.updateProduct(this.product.code, payload)
      .then(() => {
        this.product.synchronizeEc = true // Update current product
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
      .catch((ex: Error) => {
        this.$store.dispatch(ActionTypes.SHOW_TOAST, {
          title: this.$t('product_detail.structure.button_synchronize'),
          variant: 'danger',
          message: `Error: ${ex.message}`
        })
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
  }

  private generateStructureManual(value: boolean) {
    const payload = { autoGenerate: value }
    this.$store.commit(MutationTypes.SET_LOADING, true)
    ApiClient.updateProduct(this.product.code, payload)
      .then(() => {
        this.product.autoGenerate = value // Update current product
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
      .catch((ex: Error) => {
        this.$store.dispatch(ActionTypes.SHOW_TOAST, {
          title: this.$t('product_detail.structure.button_synchronize'),
          variant: 'danger',
          message: `Error: ${ex.message}`
        })
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
  }

  private regenerateWebpack() {
    const payload = {
      id: this.product.code,
      force: true,
      tenant: Utils.getTenantFromProduct(this.product)
    }
    this.$store.commit(MutationTypes.SET_LOADING, true)
    ApiClient.regenerateWebpack(payload)
      .then(() => {
        this.$store.dispatch(ActionTypes.SHOW_TOAST, {
          title: this.$t('product_detail.structure.feedback.success_title_regenerate_webpack'),
          variant: 'success',
          message: this.$t('product_detail.structure.feedback.success_message_regenerate_webpack')
        })
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
      .catch((ex) => {
        let errorMessage = this.$t('product_detail.structure.feedback.error_message_regenerate_webpack')
        if (ex.response?.data) {
          const responseData = ex.response.data as RegenerateWebpackResponse

          if (responseData.message) {
            errorMessage = responseData.message
          }

          if (responseData.data && Array.isArray(responseData.data) && responseData.data.length > 0) {
            const fileErrors = responseData.data
              .map((err: { type: string; message: string }) => `- ${err.message}`)
              .join('\n')

            errorMessage += `\n\n${fileErrors}`
          }
        }

        this.$store.dispatch(ActionTypes.SHOW_TOAST, {
          title: this.$t('product_detail.structure.feedback.error_title_regenerate_webpack'),
          variant: 'danger',
          message: errorMessage
        })
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
  }

  private regenerateCodesAllStructure() {
    this.$store.commit(MutationTypes.SET_LOADING, true)
    ApiClient.regenerateElementCodesInProduct(this.product.code).then(() => {
      this.$emit('elementUpdated', null)
      this.$store.dispatch(ActionTypes.SHOW_TOAST, {
        title: this.$t('upsert_element_modal_component.button_refactor_all_codes_product'),
        variant: 'success',
        message: this.$t('upsert_element_modal_component.feedback.success_update')
      })
      this.$store.commit(MutationTypes.SET_LOADING, false)
    }).catch((ex) => {
      this.$store.dispatch(ActionTypes.SHOW_TOAST, {
        title: this.$t('upsert_element_modal_component.button_refactor_all_codes_product'),
        variant: 'danger',
        message: `${ex.response.data.message}`
      })
      this.$store.commit(MutationTypes.SET_LOADING, false)
    })
  }

  private generateSampleProduct() {
    this.$store.commit(MutationTypes.SET_LOADING, true)
    ApiClient.generateSampleProduct(this.product.code).then(() => {
      this.$store.dispatch(ActionTypes.SHOW_TOAST, {
        title: this.$t('product_detail.structure.button_generate_sample'),
        variant: 'success',
        message: `${this.$t('product_detail.structure.generate_sample_feedback_success')}`
      })
      this.$store.commit(MutationTypes.SET_LOADING, false)
    })
      .catch((ex) => {
        this.$store.dispatch(ActionTypes.SHOW_TOAST, {
          title: this.$t('product_detail.structure.button_generate_sample'),
          variant: 'danger',
          message: `${this.$t('product_detail.structure.generate_sample_feedback_error')} ${ex.response.data.message}`
        })
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
  }

  private copyProcessedRelatedPartsPdfs() {
    this.$store.commit(MutationTypes.SET_LOADING, true)
    ApiClient.copyProcessedRelatedPartsPdfs(this.product.code)
      .then((response: CopyProcessedRelatedPartsResponse) => {
        this.showCopyProcessedResult(response)
      })
      .catch((err) => {
        const response = err?.response?.data as CopyProcessedRelatedPartsResponse | undefined
        if (response && response.data) {
          this.showCopyProcessedResult({ ...response, success: false })
        } else {
          this.copyProcessedResult = null
          this.copyProcessedMessage = this.$t('feedback.error_message_generic').toString()
          this.copyProcessedSuccess = false
          this.$bvModal.show('copyProcessedRelatedPartsResultModal')
        }
      })
      .finally(() => {
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
  }

  private showCopyProcessedResult(response: CopyProcessedRelatedPartsResponse) {
    this.copyProcessedResult = response.data ?? null
    this.copyProcessedMessage = response.message ?? ''
    this.copyProcessedSuccess = response.success
    this.$bvModal.show('copyProcessedRelatedPartsResultModal')
  }

  private refreshTree() {
    this.$emit('elementUpdated')
  }

  private regenerateStaticNodes() {
    this.$store.commit(MutationTypes.SET_LOADING, true)
    ApiClient.regenerateStaticNodes(this.product.code).then(() => {
      this.$emit('elementUpdated', null)
      this.$store.dispatch(ActionTypes.SHOW_TOAST, {
        title: this.$t('product_detail.structure.button_generate_static_nodes'),
        variant: 'success',
        message: `${this.$t('product_detail.structure.generate_static_nodes_feedback_success')}`
      })
      this.$store.commit(MutationTypes.SET_LOADING, false)
    })
      .catch(() => {
        this.$store.dispatch(ActionTypes.SHOW_TOAST, {
          title: this.$t('product_detail.structure.button_generate_static_nodes'),
          variant: 'danger',
          message: `${this.$t('product_detail.structure.generate_static_nodes_feedback_error')}`
        })
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
  }

  private moveElement(stat: Stat<Element>, isUp = false) {
    const elementToMove = stat.data
    const elementTarget = this.findElementTarget(elementToMove, stat, isUp)

    const payload: ElementPostMove = {
      elementIdToMove: elementToMove.id,
      pathTarget: elementTarget.path
    }
    this.$store.commit(MutationTypes.SET_LOADING, true)
    ApiClient.moveElement(payload, elementToMove.id)
      .then((element: Element) => {
        this.$emit('elementMove', element)
        this.$store.dispatch(ActionTypes.SHOW_TOAST, {
          title: this.$t('product_detail.structure.move_title'),
          variant: 'success',
          message: this.$t('product_detail.structure.feedback.success_move') + ` ${element.name}`
        })
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
      .catch((ex: any) => {
        this.$store.dispatch(ActionTypes.SHOW_TOAST, {
          title: this.$t('product_detail.structure.move_title'),
          variant: 'danger',
          message: `${ex.response.data.message}`
        })
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
  }

  private findElementTarget(elementToMove: Element, stat: Stat<Element>, isUp: boolean) {
    let indexElementTarget = 0
    let children: Element[] = []

    if (stat.parent && stat.parent !== undefined) {
      children = stat.parent.children.map((item: Stat<Element>) => item.data as Element)
    } else {
      children = this.product.elements
    }

    children.forEach(function(element: Element, index: number) {
      if (element.id === elementToMove.id) {
        indexElementTarget = index
      }
    })

    if (isUp && indexElementTarget > 0) {
      indexElementTarget += -1
    }

    if (!isUp && indexElementTarget < (children.length - 1)) {
      indexElementTarget += 1
    }

    return children[indexElementTarget]
  }

  private getCodeToShow(element: Element) {
    return element.metadata.fileNameDefault ? element.metadata.fileNameDefault : (element.integrationCode ? element.integrationCode : element.code)
  }

  /**
   * All detected structure errors in the product (catalogued by type)
   */
  get structureErrors(): StructureError[] {
    const errors: StructureError[] = []

    // A code may not be duplicated among siblings: elements that share the
    // same parent (i.e. at the same level of the tree). The same code reused
    // in a different sibling group (a different parent) is perfectly valid.
    const checkSiblings = (siblings: Element[]) => {
      // Duplicated codes: more than one sibling sharing the same code
      const elementsByCode = new Map<string, Element[]>()
      siblings.forEach((element: Element) => {
        const code = (element.code || '').trim()
        if (code !== '') {
          if (!elementsByCode.has(code)) {
            elementsByCode.set(code, [])
          }
          const elementsWithCode = elementsByCode.get(code)
          if (elementsWithCode) {
            elementsWithCode.push(element)
          }
        }
        // Recurse into this element's own children (the next sibling group)
        if (element.elements && element.elements.length > 0) {
          checkSiblings(element.elements)
        }
      })

      elementsByCode.forEach((elements: Element[]) => {
        if (elements.length > 1) {
          elements.forEach((element: Element) => {
            errors.push({
              elementId: element.id,
              elementName: element.name,
              code: element.code,
              fileName: element.metadata?.fileNameDefault || '',
              type: STRUCTURE_ERROR_TYPE_DUPLICATED_CODE
            })
          })
        }
      })
    }

    checkSiblings(this.product.elements || [])

    return errors
  }

  /**
   * Index of structure errors by element id for O(1) per-row lookups.
   */
  get errorsByElementId(): Map<string, StructureError[]> {
    const map = new Map<string, StructureError[]>()
    this.structureErrors.forEach((error: StructureError) => {
      if (!map.has(error.elementId)) {
        map.set(error.elementId, [])
      }
      const elementErrors = map.get(error.elementId)
      if (elementErrors) {
        elementErrors.push(error)
      }
    })
    return map
  }

  private getElementErrors(node: Element): StructureError[] {
    return this.errorsByElementId.get(node.id) || []
  }

  /**
   * Errors to surface on a node's row in the main tree: its own errors plus,
   * for nodes whose nested sub-structure is NOT rendered in the main tree
   * (drill-in nodes opened through the structure-info modal), the errors of
   * their hidden descendants. This way duplicates buried in sub-structures are
   * still flagged on the visible parent instead of going unnoticed.
   */
  private getRowErrors(node: Element): StructureError[] {
    const ownErrors = this.getElementErrors(node)
    const hidesSubStructure = (!node.childrens || node.childrens.length < 1) && !!node.elements && node.elements.length > 0
    if (!hidesSubStructure) {
      return ownErrors
    }
    const nestedErrors = (Utils.flattenTreeNodes(node, 'elements') as Element[])
      .filter((descendant: Element) => descendant.id !== node.id)
      .flatMap((descendant: Element) => this.getElementErrors(descendant))
    return [...ownErrors, ...nestedErrors]
  }

  private getElementErrorsTitle(node: Element): string {
    const labels = this.getRowErrors(node).map((error: StructureError) => this.$t('structure_errors_modal.types.' + error.type) as string)
    return [...new Set(labels)].join(', ')
  }

  private showStructureErrors() {
    this.$bvModal.show('structureErrorsModal')
  }

  private closePopover(id: string) {
    this.$root.$emit('bv::hide::popover', id)
  }
}
